import { useFeatureFlagEnabled } from "posthog-js/react";

import { useAccount } from "@/hooks";

export function useShowMaintenancePage() {
  const { account } = useAccount();
  const email = account?.email || "";

  const showMaintenancePage = useFeatureFlagEnabled("showMaintenancePage");

  if (!showMaintenancePage) {
    return false;
  }

  if (!email) {
    return true;
  }

  return !email.endsWith("@mylot.ai");
}
